import { UOMCoefficientEnum } from 'domains/svcDomain';
import { useMemo } from 'react';
import { ConfigSvcProps } from '..';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const CommonJobSvcCotainer = (props: ConfigSvcProps) => {
  const {
    children,
    jobOptionSvc,
    customerParameterLabels,
    customerOptions,
    isOneof,
  } = props;
  const hideSvcContainer = useHideSvcContainer(props);

  const hideJobSvcSpec = useMemo(() => {
    return (
      Boolean(!jobOptionSvc?.specs?.length) ||
      (Boolean(!customerParameterLabels?.length) &&
        Boolean(!jobOptionSvc?.parameterLabels?.length))
    );
  }, [jobOptionSvc, customerParameterLabels]);

  const hideJobSvcOption = useMemo(() => {
    return (
      Boolean(!customerOptions?.length) &&
      Boolean(!jobOptionSvc?.options?.length)
    );
  }, [customerOptions, jobOptionSvc]);

  const hideJobSvcQuantityPerBundle = useMemo(() => {
    return jobOptionSvc?.uomCoefficient !== UOMCoefficientEnum.BUNDLE_COUNT;
  }, [jobOptionSvc]);

  const hideJobSvcInstructions = useMemo(() => {
    return Boolean(!jobOptionSvc?.showInstructions);
  }, [jobOptionSvc]);

  const hideJobSvcMessage = useMemo(() => {
    return Boolean(!jobOptionSvc?.message);
  }, [jobOptionSvc]);

  return (
    <div
      className={
        isOneof
          ? ''
          : `base-service-container ${
              hideSvcContainer ? 'base-service-container-disabled' : ''
            }`
      }
      hidden={
        hideJobSvcSpec &&
        hideJobSvcOption &&
        hideJobSvcQuantityPerBundle &&
        hideJobSvcInstructions &&
        hideJobSvcMessage
      }
    >
      {children}
    </div>
  );
};

export default CommonJobSvcCotainer;
